import { ref } from 'vue';
import CampaignTemplatesAPI from 'dashboard/api/campaignTemplates';

// Module-level cache: templates are static seed data, so one fetch serves
// every gallery open for the session.
const templates = ref([]);
const isFetching = ref(false);
const hasFetched = ref(false);

/**
 * The campaign template list backing the gallery. `fetchTemplates` loads
 * once and caches; a failed fetch leaves the list empty (the gallery still
 * offers "start from scratch") and lets the next open retry.
 */
export function useCampaignTemplates() {
  const fetchTemplates = async () => {
    if (hasFetched.value || isFetching.value) return;

    isFetching.value = true;
    try {
      const { data } = await CampaignTemplatesAPI.get();
      templates.value = data;
      hasFetched.value = true;
    } catch (error) {
      // Ignore error: the gallery degrades to the scratch card.
    } finally {
      isFetching.value = false;
    }
  };

  return { templates, isFetching, fetchTemplates };
}
